<template>
  <el-dialog
    title="应急点位管理"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" :rules="rules">
        <el-form-item label="点位类型" prop="pointTypes">
          <el-select
            placeholder="点位类型"
            clearable
            v-model="formInline.pointTypes"
            @change="pointTypeChange"
          >
            <el-option
              v-for="item in pointTypeOptions"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="点位名称" prop="pointId">
          <el-select
            placeholder="点位名称"
            clearable
            multiple
            v-model="formInline.pointId"
          >
            <el-option
              v-for="item in pointOptions"
              :key="item.id"
              :label="item.pointName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addEmergency } from "@/api/crashInfo.js";
import { getPointLevelListPage, getPointTypeListPage } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formInline: {
        pointTypes: "",
        pointId: []
      },
      pointTypeOptions: [],
      pointOptions: [],
      rules: {
        pointTypes: [
          { required: true, message: "请选择点位类型", trigger: "blur" }
        ],
        pointId: [
          { required: true, message: "请选择点位名称", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
    this.getPointLevelListPageFun();
  },
  methods: {
    pointTypeChange() {
      this.getPointLevelListPageFun();
    },
    // 点位类型
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointTypeOptions = res.data.data.records;
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: 1,
        pointType: this.formInline.pointTypes,
        size: 99999
      };
      const res = await getPointLevelListPage(params);
      this.pointOptions = res.data.data.records || [];
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async addOrUpdateFun() {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let pointNameTypes = JSON.parse(JSON.stringify(this.pointTypeOptions)).find(item => item.id == this.formInline.pointTypes).typeName
      let ghPointEmergencyList = [];
      this.formInline.pointId.forEach(element => {
        ghPointEmergencyList.push({
          pointTypes: this.formInline.pointTypes,
          pointNameTypes: pointNameTypes,
          pointId: element
        });
      });
      let params = {
        ghPointEmergencyList: ghPointEmergencyList
      };
      const res = await addEmergency(params);

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/crashInfo/crashPoint/components/addDialog.vue